/**
 * @fileoverview Service para operações de tramitação.
 *
 * Gerencia operações relacionadas a transações/tramitações,
 * incluindo busca de destinos permitidos e envio para revisão.
 *
 * @module services/TransactionsService
 * @see {@link module:typedef~Transaction} para definição de Transaction
 */

import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';
import headers from '@/constants/headers';

axios.defaults.headers.common.Authorization = `Bearer ${headers.access_token}`;

/**
 * Service de tramitações.
 * @namespace transactionsService
 */
const transactionsService = {
  /**
   * Busca próximas unidades administrativas disponíveis para tramitação.
   * Considera o fluxo definido no tipo de pasta.
   *
   * @returns {Promise<AdministrativeUnit[]>} Lista de unidades permitidas
   */
  async nextAdministrativeUnits(){
    return (await axios.get(`${API_V2_URL()}/transactions/transactions/next_administrative_units`)).data
  },

  /**
   * Envia pasta para revisão (cria minuta).
   * Usado quando documento precisa aprovação antes de assinatura.
   *
   * @param {Object} payload - Dados da revisão
   * @param {number} payload.folder_id - ID da pasta
   * @param {number} payload.to_user_id - ID do revisor
   * @returns {Promise<import('axios').AxiosResponse>}
   */
  sendFolderToReview(payload) {
    return axios.post('transaction_flows/transactions/transaction_to_revision', payload);
  },

  /**
   * Busca campos disponíveis para despacho de tramitação.
   *
   * @returns {Promise<import('axios').AxiosResponse<Field[]>>}
   */
  getFieldsTransaction() {
    return axios.get('transaction_flows/transactions/fields_transaction');
  },
};

export default transactionsService;



// WEBPACK FOOTER //
// ./src/services/TransactionsService.js